<form class="email-form-container" [formGroup]="emailForm" (ngSubmit)="onSubmit()">
    <ng-scrollbar class="email-form">
        <div class="email-form-inner-container" id="mainDiv">
            <div formGroupName="sender" class="sender-inputs">
                <!-- Sender email input -->
                <div class="input-container">
                    <app-smash-input type="email" placeholder="{{ 'UPLOADER_EMAIL_FORM_PLACEHOLDER_YOUR_EMAIL' | translate }}"
                        formControlName="email" [error]="submitted && senderEmailControls.errors">
                        <div *ngIf="submitted && senderEmailControls.errors" error>{{ 'UPLOADER_EMAIL_FORM_ALERT_MESSAGE_INCORRECT_EMAIL' | translate }}</div>
                    </app-smash-input>
                </div>
                <div class="icon-toggle-sender-details" 
                    [ngClass]="{ 'icon-smash_less': senderInputDetailsToggled, 'icon-smash_plus': !senderInputDetailsToggled, }" 
                    (click)="toggleSenderInput()"></div>
                <!-- Sender name input -->
                <div class="input-container" *ngIf="senderInputDetailsToggled">
                    <app-smash-input type="text" placeholder="{{ 'UPLOADER_EMAIL_FORM_PLACEHOLDER_SENDER' | translate }}" formControlName="name"
                        tooltipContent="{{'UPLOADER_EMAIL_FORM_DESCRIPTION' | translate}}">
                    </app-smash-input>
                </div>
            </div>
            <!-- Receivers input -->
            <div *ngIf="!dropbox" class="input-contacts">
                <app-smash-input-tag formControlName="receivers" (updateSuggestList)="onSuggestListUpdated($event)" [suggestList]="contacts$ | async"
                    [error]="submitted && f.receivers.errors"></app-smash-input-tag>
            </div>
            <!-- Subject input -->
            <div class="input-container">
                <app-smash-input type="text" placeholder="{{ 'UPLOADER_EMAIL_FORM_PLACEHOLDER_SUBJECT' | translate }}" formControlName="title">
                </app-smash-input>
            </div>
            <!-- Message input -->
            <app-smash-input-message formControlName="description" placeholder="{{'UPLOADER_EMAIL_FORM_PLACEHOLDER_MESSAGE' | translate }}">
            </app-smash-input-message>
        </div>
    </ng-scrollbar>
    <button type="submit" (click)="onSubmit(); false"></button>
</form>